import { memo, useMemo } from "react";
import { Link } from "react-router-dom";
import ItemsList from "../../../components/ItemsList/ItemsList";
import { convertDate, formatDescription } from "../../Board/Board";
export default memo(function SlaTasks({ tasks = [] }) {
  const tasksHeaders = useMemo(() => {
    return [
      {
        field: "date",
        headerName: "Date create",
        sortable: true,
        type: "string",
        maxWidth: 150,
        flex: 1,
        valueGetter: (params) => convertDate(params.row.asana_created_at),
      },
      {
        field: "name",
        headerName: "Number",
        sortable: false,
        type: "string",
        flex: 1,
        renderCell: (item) => (
          <>
            <Link to={item.row?.permalink_url} target="_blank">
              <span
                dangerouslySetInnerHTML={{
                  __html: formatDescription(item.value),
                }}
              />
            </Link>
          </>
        ),
      },
      {
        field: "notes",
        headerName: "Description",
        sortable: false,
        flex: 1,
        type: "string",
        renderCell: (item) => (
          <span
            dangerouslySetInnerHTML={{
              __html: formatDescription(item.value),
            }}
          />
        ),
      },
      {
        field: "reporter",
        headerName: "Reporter",
        sortable: false,
        maxWidth: 200,
        flex: 1,
      },
      {
        field: "rate",
        headerName: "Rate",
        sortable: true,
        maxWidth: 100,
        flex: 1,
      },
    ];
  }, []);

  return (
    <ItemsList
      items={tasks}
      headers={tasksHeaders}
      server={false}
      gridId="rate-tasks"
      totalCount={tasks.length}
      defaultPageSize={20}
    />
  );
});
